// extracted by mini-css-extract-plugin
export var active = "_by-7";
export var container = "_by-0";
export var evenWidth = "_by-4";
export var large = "_by-5";
export var outlet = "_by-8";
export var slide = "_by-2";
export var small = "_by-6";
export var tab = "_by-3";
export var tabs = "_by-1";